/**
 * Adaptador para publicar módulos TS de forma que puedan ser utilizados desde
 * los js con la maquetación vieja.
 *
 * Este módulo se importará en structureLegacy de common. Lo que no quita que
 * cada web podrá defenir una extensión del mismo o sobreescribirlo (aunque
 * ahora no es el caso).
 *
 * Los páginas que parten de markup no deben incluir este js.
 */

import * as formValidator from "../components/form/formValidation";
import * as validators from "../components/validators";

/**
 * Definición de los módulos exportados.
 * Realmente es informativo porque en legacy no hay tipado.
 */
export interface ImsBridge {
  /* Funciones de validación de un valor. */
  validators: typeof validators;

  /* Módulo para la validación de formularios. */
  formValidator: typeof formValidator;
}

/**
 * Extensiones que añadimos al contexto global Window en common.
 * Se comparten módulos para todas las webs.
 */
interface ImsWindowExt {
  ImsBridge: ImsBridge;
  /* Por compatiblidad hacia atras, también se exporta FormValidation como
   * Validation incluyendo los validadores. Es tal cual estaba en validation.js
   */
  Imserso: {
    Validation: typeof formValidator & { validators: typeof validators };
  };
}

/* Definimos localmente window con su extensión */
declare const window: typeof Window & ImsWindowExt;

/* Añadir el bridge */
window.ImsBridge = {
  formValidator,
  validators,
};

/* Esto se tiene que cargar siempre después de main.js, sino no se añadirá al
 * objeto ya existente. Si se crease antes se sobreescribiría y se perdería. */
window.Imserso.Validation = {
  ...formValidator,
  validators: validators,
};
